/**
 * Created by danielg on 8/12/15.
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var lpModelController = require('web-agent-assets-js/lpModelController');
    var lpSessionStorageController = require('web-agent-assets-js/lpSessionStorageController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');


    /////////// CLASS DEFINITION /////////////
    var BaseController = function (options) {
        _init.call(this, options);
    };

    /////////// PUBLIC CLASS FUNCTIONS /////////////

    BaseController.extend = function(inheritingConstructor) {
        return _extend.call(this, BaseController, inheritingConstructor);
    };

    /////////// PUBLIC INSTANCE FUNCTIONS /////////////

    /**
     * The default application type. Inheriting controllers should set their own applicationType on the prototype.
     * @type {string}
     */
    BaseController.prototype.applicationType = 'BaseController';

    /**
     * Gets a parameter from the model
     * @param key - The key for the model
     * @returns {*}
     */
    BaseController.prototype.getModelParam = function (key) {
        if (this._modelController) {
            return this._modelController.getModelParam(key);
        } else if (this.logger) {
            this.logger.warn('No model Controller!', 'getModelParam');
        }
    };

    /**
     * Binds to a parameter in the model
     * @param key - The key for the model
     * @param callback - The callback function which will be triggered when there's a change in the parameter's value
     * @param context - The context for the callback function
     * @param trigger - If true, the callback will be triggered for existing data. If false - it won't.
     */
    BaseController.prototype.bindModelParam = function(key, callback, context, trigger) {
        if (this._modelController) {
            this._modelController.bindModelParam(key, callback, context, trigger);
        } else if (this.logger) {
            this.logger.warn('No model Controller!', 'bindModelParam');
        }
    };

    /**
     * Unbinds from a parameter in the model
     * @param key - The key for the model
     * @param callback - The callback function which was used to bind
     * @param context - The context which was used to bind
     */
    BaseController.prototype.unbindModelParam = function(key, callback, context) {
        if (this._modelController) {
            this._modelController.unbindModelParam(key, callback, context);
        } else if (this.logger) {
            this.logger.warn('No model Controller!', 'unbindModelParam');
        }
    };

    /**
     * Gets an object from the session storage based on the provided data
     * @param data.name - The name for the session storage
     * @param data.key - The key for the session storage
     * @returns {*} - The stored object
     */
    BaseController.prototype.getSessionData = function(data) {
        if (this._sessionStorageController && data && this.applicationType) {
            return this._sessionStorageController.getSessionData(_addApplicationTypeToName(data, this.applicationType));
        }
    };

    /**
     * Saves an object to the session storage based on the provided data
     * @param data.name - The name for the session storage
     * @param data.key - The key for the session storage
     * @param data.value - The object to store
     */
    BaseController.prototype.saveSessionData = function(data) {
        if (this._sessionStorageController && data && this.applicationType) {
            this._sessionStorageController.saveSessionData(_addApplicationTypeToName(data, this.applicationType));
        }
    };

    /**
     * Removes the session storage based on the provided data
     * @param data.name - The name for the session storage
     * @param data.key - The key for the session storage
     */
    BaseController.prototype.removeSessionData = function(data) {
        if (this._sessionStorageController && data && this.applicationType) {
            this._sessionStorageController.removeSessionData(_addApplicationTypeToName(data, this.applicationType));
        }
    };

    /////////// PRIVATE FUNCTIONS /////////////

    /**
     * Extends a parent to be the prototype of a child
     * @param parent The parent which the child wants to inherit
     * @param child The child who wants to inherit from the parent
     * @returns {Function} A child which inherits from the parent
     * @private
     */
    function _extend(parent, child) {
        var extended = function(options) {
            parent.call(this, options);
            child.call(this, options);
        };
        // TODO: We need to make sure the browser supports "Object.create()". If not - use _.extend
        extended.prototype = Object.create(parent.prototype);
        extended.prototype.constructor = child;
        extended.extend = function(inheritor) {
            return _extend.call(this, extended, inheritor);
        };
        var singletonInstance;
        extended.getInstance = function(settings) {
            if (!singletonInstance) {
                singletonInstance = new extended(settings);
            }
            return singletonInstance;
        };
        return extended;
    }

    /**
     * Initializes the controller
     * @param options.model The model to set
     * @param options.applicationType The application type to set
     */
    function _init(options) {
        if (options) {
            _setModel.call(this, options.model || options);
            _setApplicationType.call(this, options.applicationType);
        }
        _createSessionStorageController.call(this);
        _createLogger.call(this);
    }

    /**
     * Sets the model for the controller
     * @param model - The model
     */
    function _setModel(model) {
        if (model) {
            this.model = model;
            this._modelController = new lpModelController(model);
        }
    }

    /**
     * Sets the Application Type (name) for the controller
     * @param applicationType
     */
    function _setApplicationType(applicationType) {
        if (applicationType) {
            this.applicationType = applicationType;
        }
    }

    /**
     * Creates a controller for the session storage
     * @private
     */
    function _createSessionStorageController() {
        this._sessionStorageController = new lpSessionStorageController();
    }

    /**
     * Creates the logger for the controller
     * @private
     */
    function _createLogger() {
        this.logger = WebAgentLogger.getLogger(this.applicationType);
    }

    /**
     * Adds the application type to the name of an object
     * @param data
     * @private
     */
    function _addApplicationTypeToName(data, namePrefix) {
        var dataToUse = lpUtils.cloneObject(data);
        dataToUse.name = namePrefix + '_' + dataToUse.name;
        return dataToUse;
    }

    return BaseController;

});
